// extracted by mini-css-extract-plugin
export default {"tariffTable":"Table_tariffTable__JOVnF"};